"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const category_date_select_filter_item_1 = require("./category-date-select-filter-item");
const filter_item_type_1 = require("./filter-item-type");
class MonthFilterItem extends category_date_select_filter_item_1.CategoryDateSelectFilterItem {
    constructor(id, label, onValueChange, defaultValues = null, isCacheable = true, searchCategoryFields = []) {
        super(id, label, onValueChange, defaultValues, filter_item_type_1.FilterItemType.CATEGORY_MONTH);
        this.defaultValues = defaultValues;
        this.isCacheable = isCacheable;
        this.searchCategoryFields = searchCategoryFields;
    }
}
exports.MonthFilterItem = MonthFilterItem;
//# sourceMappingURL=month-filter-item.js.map